import { Box, Switch, Text } from "@chakra-ui/react";
import { TenantDetalhe } from "core/features/tenants/typings/tenant";
import { Control } from "react-hook-form";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import SelectTipoEstrutura from "ui/components/Input/SelectTipoEstrutura";
import SelectTipoHabitacao from "ui/components/Input/SelectTipoHabitacao";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import { TipoEstruturaMoradiaEnum } from "core/resources/enums/tenant";

function DadosDeEstrutura({
  control,
}: {
  control: Control<TenantDetalhe, object>;
}) {
  return (
    <Box>
      <Row gutter={16}>
        <Box as={Col} md={8} mb={3}>
          <Field
            label="Área total (m2)"
            control={control}
            name="areaConstruida"
            render={({ field, isInvalid }) => (
              <InputMoney isInvalid={isInvalid} {...field} />
            )}
          />
        </Box>

        <Box as={Col} md={8} mb={3}>
          <Field
            label="Tipo de condomínio"
            control={control}
            name="tipoHabitacao"
            render={({ field, isInvalid }) => (
              <SelectTipoHabitacao isInvalid={isInvalid} {...field} />
            )}
          />
        </Box>

        <Box as={Col} md={8} mb={3}>
          <Field
            label="Tipo de estrutura"
            control={control}
            name="tipoEstrutura"
            render={({ field, isInvalid }) => (
              <SelectTipoEstrutura isInvalid={isInvalid} {...field} />
            )}
          />
        </Box>
      </Row>

      <Box as={Row} mt={3} gutter={16}>
        <Box as={Col} md={8}>
          <Field
            label="Quantidade de unidades"
            name="quantidadeUnidades"
            inputProps={{
              type: "number",
              placeholder: "Quantidade de unidades",
            }}
            control={control}
          />
        </Box>

        <Box as={Col} md={8}>
          <Field
            label="Tipo de estrutura das unidades"
            name="tipoEstruturaMoradia"
            control={control}
            render={({ field }) => (
              <SelectBaseAntd
                size="large"
                {...field}
                options={[
                  { label: "Nenhum", value: '' },
                  { label: "Bloco", value: TipoEstruturaMoradiaEnum.Bloco },
                  { label: "Quadra", value: TipoEstruturaMoradiaEnum.Quadra },
                ]}
              />
            )}
          />
        </Box>

        <Box as={Col} md={8} pt="30px">
          <Field
            name="substitutoTributario"
            control={control}
            render={({ field }) => (
              <Switch
                isChecked={!!field.value}
                onChange={() => field.onChange(!field.value)}
              >
                <Text as="span" position="relative" top={"-2px"}>
                  Substituto tributário?
                </Text>
              </Switch>
            )}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default DadosDeEstrutura;
